import { DuetLangObject, getLocaleString } from "../../utils/language-utils"
import { parsePossibleJSON } from "../../utils/string-utils"

export type DuetUploadErrorCode = {
  type: string | undefined
  system_message: string | undefined
  message: DuetLangObject | undefined
}

export type DuetUploadErrorCodes = DuetUploadErrorCode[] | string

export const getError = (code: string, errorCodes: DuetUploadErrorCodes): DuetUploadErrorCode => {
  let error: DuetUploadErrorCode = {
    type: undefined,
    system_message: undefined,
    message: undefined,
  }
  errorCodes = parsePossibleJSON(errorCodes) as DuetUploadErrorCode[]

  error = errorCodes.filter(errorItem => {
    // the == is intentional we may be comparing numbers to strings - and that is ok here
    return errorItem.type == code
  })[0]
  if (!error) {
    error = errorCodes.filter(errorItem => {
      return errorItem.type === "default"
    })[0]
  }
  return error
}

export const getI18nError = (errorCode: string, errorCodes: DuetUploadErrorCodes) => {
  const errorFromJson = getError(errorCode, errorCodes)
  const i18String = getLocaleString(errorFromJson.message)
  if (i18String === "" || !i18String) {
    return errorFromJson.system_message
  } else {
    return i18String
  }
}
